export function toDegree (y, x) {
  return Math.atan2(y, x) * (180 / Math.PI);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/toDegree.js
// module id = 78
// module chunks = 0